<template>
<section>
  <v-parallax v-bind:src="require('../../assets/pictures/Teutonia-WG.jpeg')"
    height="600">
    <v-layout
      column
      align-center
      justify-center
      class="dark-grey--text"
    >
      <h1 class="mb-2 display-2 text-xs-center">Wohnen bei Teutonia</h1>
      <h1 class="mb-2 subtitle-2 text-xs-center">
        <a href="https://www.wg-gesucht.de/4125799.html?ma=1"
          title="Zimmer Frei!">Wir haben noch Zimmer frei!
        </a>
      </h1>
      <v-btn
        class="blue lighten-2 mt-5"
        dark
        large
        @click="firstDialog = !firstDialog"
      >
        Impressionen
      </v-btn>
      <v-dialog
        v-model="firstDialog"
        lazy
        width="100%"
      >
        <v-card>
          <WgGallery/>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-parallax>
</section>
</template>

<script>
import WgGallery from './WgGallery.vue';

export default {
  components: {
    WgGallery,
  },

  data: () => ({

    firstDialog: false,


  }),
};
</script>
